import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import { AnimatedButton } from '@/components/ui/animated-button';
export function FundingEntryFeedback(t0) {
  const $ = _c(18);
  const {
    expired,
    noPaymentTaken,
    onSignIn,
    onRetry
  } = t0;
  const t = useTranslations("onramp");
  let t1;
  if ($[0] !== expired || $[1] !== t) {
    t1 = expired ? t("sign_in") : t("provider_unavailable");
    $[0] = expired;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <p className="text-body">{t1}</p>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== noPaymentTaken || $[6] !== t) {
    t3 = noPaymentTaken && <p className="text-caption text-foreground-secondary">{t("no_payment_taken")}</p>;
    $[5] = noPaymentTaken;
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = expired ? onSignIn : onRetry;
  let t5;
  if ($[8] !== expired || $[9] !== t) {
    t5 = expired ? t("sign_in") : t("retry");
    $[8] = expired;
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <AnimatedButton variant="secondary" onClick={t4}>{t5}</AnimatedButton>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t2 || $[15] !== t3 || $[16] !== t6) {
    t7 = <div role="alert" className="flex flex-col gap-3 rounded-card border border-border-secondary p-4">{t2}{t3}{t6}</div>;
    $[14] = t2;
    $[15] = t3;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}